import { type ReactNode } from 'react';
import PageHeader from './PageHeader';
import NotesList from './NotesList';
import { BookmarkPageProvider } from '../contexts/BookmarkPageContext';
import { Note } from '../types/api';

interface NotesListPageProps {
  children?: ReactNode;
  notes: Note[];
  isLoading?: boolean;
}

function NotesListPage({ children, notes, isLoading = false }: NotesListPageProps) {
  return (
    <BookmarkPageProvider bookmarks={[]}>
      <div className="flex flex-1 flex-col border-l border-[var(--border-default)]">
        <PageHeader mode="highlights" />

        <NotesList notes={notes} isLoading={isLoading} />

        {children}
      </div>
    </BookmarkPageProvider>
  );
}

export default NotesListPage;
